'use strict';

const React                 = require('react');
const PropTypes = require('prop-types');

const styles = require('./BuyerAssuranceTooltip-style.scss');

const BuyerAssuranceTooltip = React.createClass({
    propTypes : {
        trackLinkClick: PropTypes.func,
        showInfo: PropTypes.bool.isRequired,
        copy: PropTypes.shape({
            title: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired
        })
    },

    onClick(e) {
        // clicks on the window outside the tooltip should close the tooltip so added e.stopPropagation() here to
        // prevent this event from propagating to the window.addEventListener('click' ...) on the pdp and checkout
        e.stopPropagation();

        if (this.props.trackLinkClick && e.target.tagName === "A") {
            this.props.trackLinkClick();
        }
    },

    render() {
        const {title, text} = this.props.copy;

        // Only render if showInfo is true
        if (!this.props.showInfo) {
            return null;
        }

        return (
            <div className={styles.wrapper} onClick={this.onClick}>
                <div className={styles.content}>
                    <div key='buyer-assurance-tooltip-title'
                         className={styles.title}>{title}</div>
                    <hr className={styles.hr} />
                    <div key='buyer-assurance-tooltip-text'
                         className={styles.body}
                         dangerouslySetInnerHTML={{__html: text}}></div>
                </div>
                <div className={`${styles.triangle} triangle down`}></div>
            </div>
        );
    }
});

module.exports = BuyerAssuranceTooltip;



// WEBPACK FOOTER //
// ./assets/js/components/BuyerAssurance/BuyerAssuranceTooltip-view.jsx